import dynamic from "next/dynamic";

import { BaseLayout } from "../BaseLayout";
import layouts from "../layouts.module.css";

const PrivacyCopyLoader = dynamic(() => import("./PrivacyCopy"));
const TermsCopyLoader = dynamic(() => import("./TermsCopy"));

export type LegalCopyType = "privacy" | "terms";

type InfoLayoutProps = {
  title: string;
  description: string;
  type: LegalCopyType;
};

export const InfoLayout = ({ title, description, type }: InfoLayoutProps) => {
  return (
    <BaseLayout
      seo={{
        title: title,
        description: description,
      }}
      header={{
        type: "full",
        overlay: true,
      }}
      footer
    >
      <main className={layouts.info}>
        <section className={layouts.content}>
          {type === "privacy" ? <PrivacyCopyLoader /> : null}
          {type === "terms" ? <TermsCopyLoader /> : null}
        </section>
      </main>
    </BaseLayout>
  );
};
